<template>
  <div class="container">
    <h1
      class="mt-5 mb-5 center color-primary"
      style="font-family: Comfortaa-Bold"
    >
      Jovool
    </h1>
    <h2>Trocar sua senha</h2>
    <div class="card mb-4">
      <div class="card-body">
        <label for="password">Senha</label>
        <input
          class="form-control"
          type="password"
          v-model="user.password"
          placeholder="Senha"
        />
        <Password
          v-model="user.password"
          :strength-meter-only="true"
          @score="showScore"
        />

        <label for="password">Confirmar Senha</label>
        <input
          class="form-control"
          type="password"
          v-model="user.password_confirmation"
          placeholder="Confirmar senha Senha"
        />
        <Password
          v-model="user.password_confirmation"
          :strength-meter-only="true"
          @score="showScore"
        />
        <div class="actions">
          <button
            @click="changePassword"
            type="button"
            class="mt-3 btn btn-success"
          >
            Alterar minha senha
          </button>
        </div>

        <div v-if="success" class="mt-4 alert alert-success">
          Senha alterada com sucesso
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Password from "vue-password-strength-meter";
export default {
  components: { Password },
  props: ["reset_password_token"],
  data: () => ({
    success: false,
    user: {
      password: "",
      password_confirmation: "",
      reset_password_token: "",
    },
  }),
  methods: {
    showScore(score) {
      if (score) this.strength = score;
    },
    changePassword() {
      if (this.strength < 3) {
        this.$toast.error("Senha muito fraca, digite uma senha mais forte", {
          position: "top",
        });
        return;
      }

      if (this.user.password == "") {
        this.$toast.error("Senha não pode ficar em branco", {
          position: "top",
        });
        return;
      }

      if (this.user.password != this.user.password_confirmation) {
        this.$toast.error("Senha e confirmação de senha estão diferentes", {
          position: "top",
        });
        return;
      }
      this.user.reset_password_token = this.reset_password_token;

      axios
        .put("/candidates/password.json", { candidate: this.user })
        .then((response) => {
          this.success = true;
          // window.location = "/recruiters/dashboard";
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
